
import { useContext, useState } from 'react'
import { SubscriptionContext } from '../../../../../../contextApi/SubscriptionContext';

export default function ExampleJobItem({item, theme}) {
    const {deployDesc} = useContext(SubscriptionContext);
    const [moreInfoFlag, setMoreInfoFlag] = useState(false);
    const [isArrowHovered, setIsArrowHovered] = useState(false);
    return (
        <div>
            <div className='exampleJob' dir='rtl' style={{ backgroundColor:theme.primary_color, color:theme.accent_color, border:`0.5px solid ${theme.accent_color}`}}>
                <div className="exampleJob_time" style={{color:theme.secondary_color}}>{item.createdAt}</div>
                <div className="exampleJob_mainSection">
                    <div className="exampleJob_title" style={{borderLeft:`0.5px solid ${theme.accent_color}`}}>{item.title}</div>
                    <div className="exampleJob_desc">{item.desc}</div>
                    <div className="exampleJob_downArrow" onClick={()=>{setMoreInfoFlag(!moreInfoFlag)}} style={{scale:isArrowHovered ? "1.1" : "1"}} onMouseEnter={()=>{setIsArrowHovered(true)}} onMouseLeave={()=>{setIsArrowHovered(false)}}>▼</div>
                </div>
            {moreInfoFlag ? <div className='exampleJob_moreInfo' style={{borderTop:`0.5px solid ${theme.accent_color}`}}>
                {deployDesc(theme, item)}
            </div> : <div className='exampleJob_moreInfo_hidden'></div>}
            </div>
        </div>
    )
}
